import React from 'react';
import { FiCompass, FiLayers, FiAward, FiFeather, FiShield, FiPhone, FiHeart } from 'react-icons/fi';

const approachItems = [
  {
    title: 'Balance',
    desc: 'Proportions and spatial equilibrium guide every decision to create calm spaces.',
    icon: FiCompass,
  },
  {
    title: 'Materiality',
    desc: 'Natural, textured materials are chosen for tactility and longevity.',
    icon: FiLayers,
  },
  {
    title: 'Function',
    desc: 'Form follows use—each space is designed to be both beautiful and practical.',
    icon: FiAward,
  },
  {
    title: 'Soul',
    desc: 'We craft spaces that feel lived-in, personal and quietly refined.',
    icon: FiFeather,
  },
  {
    title: 'Reliability',
    desc: 'Absolute oversight is maintained to guarantee flawless, uncompromising execution.',
    icon: FiShield,
  },
  {
    title: 'Communication',
    desc: 'Direct, transparent dialogue is prioritized for a clear, seamless partnership.',
    icon: FiPhone,
  },
  {
    title: 'Support',
    desc: 'Steadfast dedication ensures your space continues to thrive over time.',
    icon: FiHeart,
  },
];

export default function OurApproach() {
  return (
    <section className="relative overflow-hidden py-16">
      <div className="absolute top-16 left-0 h-96 w-full bg-gradient-to-b from-[#111111]/30 to-transparent" />
      <div className="absolute inset-y-0 right-0 hidden w-1/4 bg-[radial-gradient(circle_at_top_left,_rgba(246,194,109,0.15),transparent_55%)] md:block" />

      <div className="relative mx-auto max-w-[1400px] px-6">
        <div className="space-y-10">
          <div className="relative overflow-hidden rounded-[36px] border border-white/10 bg-white/5 p-10 shadow-[0_30px_90px_rgba(0,0,0,0.4)]">
            <div className="absolute inset-y-0 left-0 w-full bg-[linear-gradient(90deg,rgba(255,255,255,0.02),transparent_45%)]" />
            <span className="relative z-10 text-sm uppercase tracking-[0.4em] text-amber-200/90">Our Approach</span>
            <h2 className="relative z-10 mt-6 max-w-2xl text-4xl font-semibold leading-tight text-white sm:text-5xl">
              Principles that shape spaces with quiet authority.
            </h2>
            <p className="relative z-10 mt-6 max-w-3xl text-base leading-8 text-gray-300">
              We distill design into seven guiding commitments—each one crafted to ensure the space feels purposeful, refined, and lived-in.
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
            {approachItems.map((item, index) => {
              const Icon = item.icon;
              const isLast = index === approachItems.length - 1;
              return (
                <div
                  key={item.title}
                  className={`relative overflow-hidden rounded-[32px] border border-white/10 bg-[#111111]/90 p-6 shadow-[0_20px_60px_rgba(0,0,0,0.3)] transition hover:-translate-y-1 hover:border-amber-500/30 ${isLast ? 'sm:col-span-2 xl:col-start-2 xl:col-end-3 sm:max-w-[28rem] sm:mx-auto xl:max-w-none' : ''}`}
                >
                  <div className="absolute -left-10 top-0 h-24 w-24 rounded-full border border-amber-300/20 bg-amber-300/10 blur-3xl" />
                  <div className="relative z-10 flex items-start gap-4">
                    <div className="mt-1 rounded-2xl border border-amber-200/30 bg-amber-200/10 p-3 text-amber-200">
                      <Icon className="h-6 w-6" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-white">{item.title}</h3>
                      <p className="mt-3 text-sm leading-7 text-gray-300">{item.desc}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
